export const TURNOVER_OPTIONS = [
  "Below Rs 1 Cr",
  "Rs 1 - 5 Cr",
  "Rs 5 - 25 Cr",
  "Rs 25 - 100 Cr",
  "Above Rs 100 Cr",
];

export const BORROWING_OPTIONS = [
  "No existing borrowing",
  "Below Rs 50 Lakh",
  "Rs 50 Lakh - 2 Cr",
  "Rs 2 - 10 Cr",
  "Above Rs 10 Cr",
];

export const FUNDING_OPTIONS = [
  "Below Rs 25 Lakh",
  "Rs 25 - 50 Lakh",
  "Rs 50 Lakh - 1 Cr",
  "Rs 1 - 5 Cr",
  "Rs 5 - 25 Cr",
  "Above Rs 25 Cr",
];

export const PURPOSE_OPTIONS = [
  "Working Capital",
  "Business Expansion",
  "Machinery / Equipment Purchase",
  "Debt Consolidation / Refinance",
  "Detailed CMA Proposal (Paid Service)",
  "Other",
];

export const FACILITY_OPTIONS = [
  "Working Capital",
  "Term Loan",
  "LAP",
  "Bill Discounting",
  "NCD / Private Credit",
];

export const LEAD_STATUSES = ["New", "Contacted", "In Progress", "Closed"];
